import type { FC } from 'react';
import type { TSummaryDetailsCardProps } from '@components/Organisms/SummaryDetails/SummaryDetails.types';
import classNames from 'classnames';

export const SummaryDetailsCard: FC<TSummaryDetailsCardProps> = ({
  children,
  className,
  title,
}) => {
  const wrapperClassNames = classNames('c-summary-details-card', className);

  if (!children) {
    return null;
  }

  return (
    <div className={wrapperClassNames}>
      <header className="c-summary-details-card__title">{title}</header>
      <div className="c-summary-details-card__content">{children}</div>
    </div>
  );
};
